const cellNames = {
  common_question: ["ردیف", "پرسش", "پاسخ"],
  question_answer: ["ردیف", "پرسش", "محصول", "وضعیت"],
  design: ["ردیف", "طرح", "ویرایش"],
  category: ["ردیف", "زیردسته", "سردسته", "طرح ها", "ویرایش"],
  products: [
    "ردیف",
    "نام محصول",
    "دسته بندی",
    "زیر دسته",
    "طرح",
    "قیمت (تومان)",
    "پیشنهاد ویژه",
    "ویرایش",
    "رنگ ها",
  ],
  productsColor: ["ردیف", "نام رنگ", "رنگ", "تعداد", "ویرایش", "تصاویر"],
  discount: ["ردیف", "کد تخفیف", "مقدار", "نوع", "تاریخ انقضا", ""],
  users: ["ردیف", "نام و نام خانوادگی", "شماره تلفن"],
  userProfile: ["ردیف", "شماره سفارش", "وضعیت", "تاریخ سفارش", " قیمت کل"],
  userAddress: ["ردیف", "آدرس", "استان", "شهر", "کدپستی"],
  orders: [
    "ردیف",
    "نام و نام خانوادگی",
    "تلفن همراه",
    "نوع کاربر",
    "وضعیت",
    "شماره سفارش",
    "تاریخ سفارش",
  ],
  factor: [
    "ردیف",
    "کالا",
    "رنگ",
    "تعداد",
    "قیمت فی (تومان)",
    "قیمت کل (تومان)",
  ],
  Answers: ["ردیف", "پاسخ", "وضعیت", "تایید / حذف"],
  newscategory: ["ردیف", "سردسته", "ویرایش"],
  views: ["ردیف", "نام ", "بازدید روز", "بازدید کل"],
};

export default function generateHeadCells(pageName) {
  return cellNames[pageName].map((items, index) => ({
    id: `${pageName} headCell ${index}`,
    numeric: false,
    disableadding: false,
    label: items,
  }));
}
